import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useContext } from 'react';
import { Box } from '@mui/material';
import { DeviceUISettingsContent } from 'console/shared/contexts/device-ui-settings/types';
import { UIControlButton } from './ui-control';
import { PanelsActions } from './panels-actions';
import { ResizeCardsSlider } from './resize-cards-slider';
export const TabControl = memo(function TabControl(props) {
    const { show_control_button } = props;
    const { sorting_mode } = useContext(DeviceUISettingsContent);
    return (_jsxs(Box, { px: 2, py: 0.5, width: "100%", boxSizing: "border-box", top: 0, zIndex: 40, position: sorting_mode ? 'static' : 'absolute', children: [_jsxs(Box, { display: "grid", alignItems: "center", gridTemplateColumns: sorting_mode && show_control_button ? '3fr 0.1fr' : '1fr', columnGap: 1, children: [sorting_mode && _jsx(ResizeCardsSlider, {}), show_control_button && _jsx(UIControlButton, {})] }), sorting_mode && show_control_button && _jsx(PanelsActions, {})] }));
});
